import React from 'react'
import Dock from "react-dock";

const Modal = ({isVisible, position, children}) => {
    return <Dock className="new" position={position ? position : "right"} isVisible={isVisible} size={0.9} duration={1000}>{children}</Dock>;
};
 
export default Modal;